/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useCreateB2BOrder = (requestId: string | null) =>
  useMutation({
    mutationFn: (data: any) =>
      client(requestId ? `services/b2b/add/job` : `services/b2b/create`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });

export const useGetB2BOrders = (data: any) =>
  useQuery({
    queryKey: [
      "GetB2BOrders",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
      data?.customerId,
      data?.onwardSPId,
      data?.sourceSPId,
      data?.pendingReason,
    ],
    queryFn: ({ signal }) =>
      client(`services/b2b/open/requests`, { data, signal }),
  });

export const useCreateB2BBulkOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/create/bulk/requests`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetB2BOrders"],
      });
    },
  });
};

export const useCancelB2BOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/cancel/services`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetB2BOrders"] });
    },
  });
};

export const useAssignB2BRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`services/b2b/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected job(s)!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetB2BOrders"],
      });
    },
  });
};

export const useGetB2BServiceDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetB2BDetails", data?.requestId],
    queryFn: () =>
      client(`services/b2b/request/details/${data?.requestId}/${data?.jobNo}`),
    enabled: Boolean(data?.requestId),
  });

export const useUpdateB2BServiceStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetB2BDetails"] });
    },
  });
};

export const useEditB2BServiceJob = (
  isReRoute?: boolean,
  scanned?: boolean,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(
        isReRoute
          ? `services/b2b/edit/job/rerouting?scanned=${Boolean(scanned)}`
          : `services/b2b/edit/job`,
        {
          data,
          successMessage: "Request updated successfully!",
        },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetB2BDetails"] });
    },
  });
};

export const useAssignBagSeals = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/bulk/bags/assignment`, {
        data,
        successMessage: "Bag Seal Assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetB2BOrders"] });
    },
  });
};

export const useGetSingCurrencyTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/download/single/currency/template`, { data }),
  });

export const useGetMultipleCurrencyTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/download/multiple/currency/template`, { data }),
  });

export const useGetCoinsTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/download/coins/template`, { data }),
  });

export const useAssignB2BBags = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(
        data?.consignmentsAssigned
          ? `services/b2b/update/consignments`
          : `services/b2b/assign/consignments`,
        {
          data,
          successMessage: "Consignments added successfully!",
        },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetB2BDetails"] });
    },
  });
};

export const useUpdateB2BBags = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/update/consignments`, {
        data,
        successMessage: "Consignments updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetB2BDetails"] });
    },
  });
};

export const useUpdateB2BAfterCompletion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/update/evhr/job`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetB2BDetails"] });
    },
  });
};

export const useAssignB2BBulkBags = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/tgd/bulk/bags/assignment`, {
        data,
        successMessage: "Consignments added successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetB2BDetails"] });
    },
  });
};

export const useValidateBulkBagsAssignment = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`services/b2b/validate/bulk/bags/assignment`, {
        data,
        errorMessage: "Invalid barcodes found.",
      }),
  });
